/**
 * Date utilities — LOCAL-TIME safe.
 *
 * Why? `Date.toISOString()` always produces a UTC string. In timezones east of
 * UTC (e.g. Türkiye, UTC+3), a Date created at *local* midnight gets shifted
 * back to the previous day's 21:00 UTC, so `toISOString().split("T")[0]`
 * silently returns the *wrong* date (one day earlier).
 *
 * Symptom: setting stop_sale for "13-14 Ağu" via the admin calendar saved
 * "12-13 Ağu" on the server.  Use these helpers everywhere we need a YMD
 * string for an API call.
 */

/** Convert a Date to "YYYY-MM-DD" using the browser's *local* timezone. */
export function toLocalYMD(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

/** "YYYY-MM-DD" for today in the local timezone. */
export function todayYMD() {
    return toLocalYMD(new Date());
}

/** "YYYY-MM-DD" for (today + n) days in the local timezone. */
export function plusDaysYMD(n) {
    const d = new Date();
    d.setDate(d.getDate() + n);
    return toLocalYMD(d);
}

/** Parse "YYYY-MM-DD" into a local-midnight Date (no timezone shift). */
export function parseYMD(s) {
    const [y, m, d] = s.split("-").map(Number);
    return new Date(y, m - 1, d);
}
